import { all, call, put, takeLatest } from "redux-saga/effects";
import connectionService from "../../services/connectionService";
import { connectionActions } from "../slices/connectionSlice";

function* getConnectionsSaga({ payload }) {
  try {
    const data = yield call(connectionService.getConnections, payload.date);
    yield put(connectionActions.getConnectionsSuccess(data));
  } catch (e) {
    yield put(connectionActions.getConnectionsError(e.response.data));
  }
}

function* createConnectionSaga({ payload }) {
  try {
    yield call(connectionService.createConnection, payload.obj);
    yield put(connectionActions.createConnectionSuccess());

    payload.onSucceeded?.();
  } catch (e) {
    yield put(connectionActions.createConnectionError(e.response.data));
  }
}

function* updateConnectionSaga({ payload }) {
  try {
    yield call(connectionService.updateConnection, payload);
    yield put(connectionActions.updateConnectionPut());
  } catch (e) {
    yield put(connectionActions.updateConnectionError(e.response.data));
  }
}

function* updateConnectionVehicleSaga({ payload }) {
  try {
    yield call(connectionService.updateConnectionVehicle, payload);
    yield put(connectionActions.updateConnectionVehicleSuccess());
  } catch (e) {
    yield put(connectionActions.updateConnectionVehicleError(e.response.data));
  }
}

function* updateConnectionDriverSaga({ payload }) {
  try {
    yield call(connectionService.updateConnectionDriver, payload);
    yield put(connectionActions.updateConnectionDriverSuccess());
  } catch (e) {
    yield put(connectionActions.updateConnectionDriverError(e.response.data));
  }
}

function* deleteConnectionSaga({ payload }) {
  try {
    yield call(connectionService.deleteConnection, payload);
    yield put(connectionActions.deleteConnectionSuccess());
  } catch (e) {
    yield put(connectionActions.deleteConnectionError(e.response.data));
  }
}

export default function* connectionSaga() {
  yield all([
    takeLatest("connection/createConnectionPost", createConnectionSaga),
    takeLatest("connection/getConnectionsFetch", getConnectionsSaga),
    takeLatest("connection/updateConnectionPut", updateConnectionSaga),
    takeLatest(
      "connection/updateConnectionVehiclePut",
      updateConnectionVehicleSaga
    ),
    takeLatest(
      "connection/updateConnectionDriverPut",
      updateConnectionDriverSaga
    ),
    takeLatest("connection/deleteConnectionDelete", deleteConnectionSaga),
  ]);
}
